import {TokenService} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../../shared/language';

export const CreateEASYCA = ({header, dataKey, refreshLazyData}) => {
  const {t} = useTranslation();

  const {render, create} = useDialogCrup({
    header,
    dataKey,
    width: '45rem',
    fields: [
      {type: 'custom', className: 'md:col-12 text-center mb-3', body: (<img src="/images/softdreams-logo.jpeg" alt=""/>)},
      {type: 'custom', className: 'md:col-12 text-center mb-0', body: <h4 className="mb-1">{t('common.signingServerSetup')}</h4>},
      {type: 'custom', className: 'md:col-12 text-center mb-5', body: <i>{t('common.certificateConnectionInfo')}</i>},
      {field: 'serialNumber', header: t('report.certificateSerial'), required: true, InputTextProps: {maxLength: 50}, className: 'md:col-12'},
      {field: 'user', header: t('auth.username'), required: true, InputTextProps: {maxLength: 50}, className: 'md:col-12'},
      {field: 'passwordCer', header: t('auth.password'), type: 'Password', required: true, className: 'md:col-6'},
      {field: 'pin', header: t('common.pinCode'), type: 'Password', required: false, className: 'md:col-6'}
    ],
    createItem: (item) => {
      item.tokenType = 2;
      return TokenService.create(item);
    },
    refreshLazyData
  });

  return {render, open: create};

}
